import {
  // Brands,
  // Counter,
  // Featured,
  //Projects,
  Services,
  // Testimonial,
  // Notes on what is there | Hero Filters Properties Services Form|
} from "../components/common/page-componets";
import {
  // Feeds,
  Filters,
  Hero,
  // Invest,
  // Speciality,
} from "../components/home/home-1";

import { Properties } from "../pages";

import { Form } from "../components/contact";

const Home = () => {
  return (
    <div className="pt-16 max-w-7xl mx-auto px-4">
      <Hero />
      <Filters />
      {/* <Invest /> */}
      {/* <Speciality /> */}
      <Properties />
      {/* <Featured /> */}
      <Services />
      {/* <Counter /> */}
      {/* <Projects /> */}
      {/* <Testimonial /> */}
      {/* <Brands /> */}
      {/* <Feeds /> */}
      <Form />
    </div>
  );
};

export default Home;
